import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import { Lang } from 'src/models/langs';

type Trl = Partial<Record<Lang, Record<string, string>>>;

export default autoGeneratedReducer<Trl>({});
